(function () {
  "use strict";
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var T = window.theme || { routes: {}, strings: {} };
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- apparitions au défilement ---------- */
  function initReveal(root) {
    var targets = $$(".rv:not(.in),.imgrv:not(.in)", root);
    if ("IntersectionObserver" in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
      targets.forEach(function (t) { io.observe(t); });
    } else {
      targets.forEach(function (t) { t.classList.add("in"); });
    }
  }
  initReveal(d);
  var hero = $(".hero");
  if (hero) requestAnimationFrame(function () { setTimeout(function () { hero.classList.add("go"); }, 60); });

  /* ---------- menu mobile ---------- */
  var burger = $(".burger"), nav = $(".nav");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      var o = nav.classList.toggle("open");
      burger.setAttribute("aria-expanded", o);
    });
  }

  /* ---------- message ---------- */
  var tt;
  function toast(m) {
    var t = $("#toast"); if (!t) return;
    t.textContent = m; t.classList.add("on");
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove("on"); }, 2800);
  }

  /* ---------- panier ---------- */
  function refreshCount() {
    fetch(T.routes.cart_js, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { var n = $("#bagCount"); if (n) n.textContent = c.item_count; })
      .catch(function () {});
  }
  d.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.matches || !f.matches("form.buy-form")) return;
    e.preventDefault();
    var btn = $("[data-add-btn]", f);
    if (btn && btn.disabled) return;
    if (btn) btn.setAttribute("aria-busy", "true");
    fetch(T.routes.cart_add + ".js", { method: "POST", body: new FormData(f), headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || T.strings.error); return; }
        toast(T.strings.added); refreshCount(); openDrawer();
      })
      .catch(function () { toast(T.strings.error); })
      .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
  });


  /* ---------- tiroir panier ---------- */
  var drawer = $("[data-cart-drawer]"), overlay = $("[data-drawer-overlay]"), dbody = $("[data-cart-body]");
  var fmt = function (cents) {
    try { return new Intl.NumberFormat("fr-FR", { style: "currency", currency: T.strings.currency || "EUR" }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + " €"; }
  };
  var esc = function (t) { var x = d.createElement("div"); x.textContent = t == null ? "" : t; return x.innerHTML; };
  function renderCart(c) {
    var n = $("#bagCount"); if (n) n.textContent = c.item_count;
    if (!dbody) return;
    if (!c.items.length) {
      dbody.innerHTML = '<div class="dempty"><p>' + esc(T.strings.empty) + '</p><a class="btn" href="' + esc(T.strings.collections) + '"><span>' + esc(T.strings.browse) + '</span></a></div>';
      return;
    }
    var h = c.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x160$1$2")) + '" alt="" width="78" height="78">' : "<span></span>";
      var v = it.variant_title ? '<span class="sub2">' + esc(it.variant_title) + "</span>" : "";
      return '<div class="dl">' + img + "<div><a href=\"" + esc(it.url) + '"><b>' + esc(it.product_title) + "</b></a>" + v +
        '<div class="qrow"><div class="dq"><button type="button" data-q="' + (i + 1) + '" data-n="' + (it.quantity - 1) + '" aria-label="Moins">−</button><span>' + it.quantity +
        '</span><button type="button" data-q="' + (i + 1) + '" data-n="' + (it.quantity + 1) + '" aria-label="Plus">+</button></div><b>' + fmt(it.final_line_price) + "</b></div>" +
        '<button class="rm" type="button" data-q="' + (i + 1) + '" data-n="0">' + esc(T.strings.remove) + "</button></div></div>";
    }).join("");
    h += '<div class="dfoot"><div class="tot"><span>' + esc(T.strings.subtotal) + "</span><b>" + fmt(c.total_price) + '</b></div><a class="btn" href="' + esc(T.routes.cart) + '"><span>' + esc(T.strings.viewcart) + '</span></a><a class="btn ghost" href="' + esc(T.routes.cart) + '" data-checkout><span>' + esc(T.strings.checkout) + "</span></a></div>";
    dbody.innerHTML = h; c.items.forEach(function (it, i) { if (it.original_line_price > it.final_line_price) { var pb = $$(".qrow > b", dbody)[i]; if (pb) pb.innerHTML = '<s class="price-was">' + fmt(it.original_line_price) + "</s> " + fmt(it.final_line_price); } });
  }
  function loadCart() {
    return fetch(T.routes.cart_js, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function openDrawer() {
    if (!drawer) return;
    loadCart();
    drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false");
    if (overlay) overlay.hidden = false;
    d.body.classList.add("lock"); drawer.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true");
    if (overlay) overlay.hidden = true;
    d.body.classList.remove("lock");
  }
  d.addEventListener("click", function (e) {
    var t = e.target;
    var opener = t.closest && t.closest("[data-cart-open]");
    if (opener && drawer && !/\/cart$/.test(location.pathname)) { e.preventDefault(); openDrawer(); return; }
    if (t.closest && (t.closest("[data-cart-close]") || t.closest("[data-drawer-overlay]"))) { closeDrawer(); return; }
    var q = t.closest && t.closest("[data-q]");
    if (q) {
      fetch(T.routes.cart + "/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: +q.getAttribute("data-q"), quantity: +q.getAttribute("data-n") }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
      return;
    }
    var qa = t.closest && t.closest("[data-quick-add]");
    if (qa) {
      qa.setAttribute("aria-busy", "true");
      fetch(T.routes.cart_add + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: +qa.getAttribute("data-quick-add"), quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) { if (!res.ok) { toast(res.j.description || T.strings.error); } else { openDrawer(); } })
        .catch(function () { toast(T.strings.error); })
        .then(function () { qa.removeAttribute("aria-busy"); });
    }
  });
  d.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeDrawer(); closeFilters(); } });

  /* ---------- menu : sous-menus mobiles ---------- */
  $$(".sub-toggle").forEach(function (b) {
    b.addEventListener("click", function () {
      var item = b.closest(".has-sub"); var o = item.classList.toggle("open"); b.setAttribute("aria-expanded", o);
    });
  });

  /* ---------- carrousels ---------- */
  $$("[data-carousel]").forEach(function (car) {
    var track = $("[data-car-track]", car), dots = $("[data-car-dots]", car);
    var host = car.closest("section");
    var prev = $("[data-car-prev]", host), next = $("[data-car-next]", host);
    if (!track) return;
    var step = function () { var s = track.querySelector(".car-slide"); return s ? s.getBoundingClientRect().width + 16 : track.clientWidth; };
    var buildDots = function () {
      if (!dots) return;
      var pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.05));
      dots.innerHTML = "";
      for (var i = 0; i < pages; i++) {
        (function (k) {
          var b = d.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Page " + (k + 1));
          b.addEventListener("click", function () { track.scrollTo({ left: k * track.clientWidth, behavior: reduce ? "auto" : "smooth" }); });
          dots.appendChild(b);
        })(i);
      }
      mark();
    };
    var mark = function () {
      if (!dots) return;
      var k = Math.round(track.scrollLeft / track.clientWidth);
      $$("button", dots).forEach(function (b, i) { b.setAttribute("aria-current", i === k); });
    };
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: reduce ? "auto" : "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: reduce ? "auto" : "smooth" }); });
    track.addEventListener("scroll", mark, { passive: true });
    window.addEventListener("resize", buildDots);
    buildDots();
  });

  /* ---------- filtres (tiroir mobile) ---------- */
  var side = $("[data-filters]");
  function closeFilters() { if (side) side.classList.remove("open"); }
  var fo = $("[data-filters-open]");
  if (fo) fo.addEventListener("click", function () { if (side) side.classList.add("open"); else { var s = $("#SortBy"); if (s) s.focus(); } });
  var fc = $("[data-filters-close]");
  if (fc) fc.addEventListener("click", closeFilters);

  /* ---------- filtres et tri ---------- */
  var cf = $("#collection-form");
  if (cf) {
    cf.addEventListener("change", function (e) {
      if (e.target.matches('input[type="checkbox"], select')) cf.submit();
    });
  }

  /* ---------- comptes clients ---------- */
  var rec = $("[data-recover]");
  if (rec) rec.addEventListener("click", function (e) { e.preventDefault(); var b = $("#recover"); if (b) { b.hidden = !b.hidden; } });
  $$("[data-address-edit]").forEach(function (a) {
    a.addEventListener("click", function (e) { e.preventDefault(); var b = $("#Edit-" + a.getAttribute("data-address-edit")); if (b) b.hidden = !b.hidden; });
  });
  $$("[data-address-delete]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      var f = d.createElement("form"); f.method = "post"; f.action = a.getAttribute("data-address-delete");
      var i = d.createElement("input"); i.type = "hidden"; i.name = "_method"; i.value = "delete"; f.appendChild(i);
      d.body.appendChild(f); f.submit();
    });
  });

  /* ---------- produits associés ---------- */
  $$("[data-recommendations]").forEach(function (box) {
    var url = box.getAttribute("data-url"); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var src = doc.querySelector("[data-recommendations]");
      if (src && src.innerHTML.trim()) { box.innerHTML = src.innerHTML; initReveal(box); }
    }).catch(function () {});
  });

  /* ---------- fiche produit : galerie et variantes ---------- */
  var sec = $("[data-product-section]");
  if (sec) {
    var slides = $$("[data-slide]", sec), thumbs = $$("[data-thumb]", sec);
    var showSlide = function (i) {
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      thumbs.forEach(function (t, k) { t.setAttribute("aria-pressed", k === i); });
    };
    thumbs.forEach(function (t) { t.addEventListener("click", function () { showSlide(+t.getAttribute("data-thumb")); }); });

    var data = {};
    try { data = JSON.parse($("[data-variants-json]").textContent); } catch (err) {}
    var idInput = $("[data-variant-id]", sec), addBtn = $("[data-add-btn]", sec), addLabel = $("[data-add-label]", sec);
    var priceEl = $("[data-price]", sec), skuEl = $("[data-sku]");
    var chosen = function () {
      return $$(".opt", sec).map(function (f) { var c = f.querySelector("input:checked"); return c ? c.value : null; });
    };
    var findVariant = function (opts) {
      for (var id in data) {
        var o = data[id].options;
        if (o.length === opts.length && o.every(function (v, i) { return v === opts[i]; })) return id;
      }
      return null;
    };
    sec.addEventListener("change", function (e) {
      if (!e.target.closest || !e.target.closest(".opt")) return;
      var opts = chosen(), id = findVariant(opts), v = id && data[id];
      if (!v) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = T.strings.unavailable; return; }
      if (idInput) idInput.value = id;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? T.strings.add : T.strings.soldout;
      if (priceEl) priceEl.innerHTML = '<span class="price-now">' + v.price + "</span>" + (v.compare ? ' <s class="price-was">' + v.compare + "</s>" : "");
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      try { history.replaceState(null, "", location.pathname + "?variant=" + id); } catch (err) {}
      if (v.media) {
        var idx = slides.findIndex(function (s) { return s.getAttribute("data-media-id") === String(v.media); });
        if (idx > -1) showSlide(idx);
      }
    });

    /* réalité augmentée : message si indisponible sur cet appareil */
    $$("model-viewer", sec).forEach(function (mv) {
      mv.addEventListener("load", function () {
        var hint = mv.parentNode.querySelector(".noar");
        if (hint && !mv.canActivateAR) hint.style.display = "block";
      });
    });
  }

  /* ---------- essai dans la pièce ---------- */
  var dlg = $("#tryDlg");
  if (dlg) {
    var cv = $("#tryCanvas"), ctx = cv.getContext("2d"), empty = $("#tryEmpty");
    var S = { bg: null, cut: new Image(), x: 0, y: 0, sc: 1, rot: 0, tilt: 1, op: 1, w: 1200, h: 800, blend: dlg.getAttribute("data-blend") };
    S.cut.crossOrigin = "anonymous";
    S.cut.onload = function () { draw(); };
    S.cut.src = dlg.getAttribute("data-image");

    var room = function () {
      var g = ctx.createLinearGradient(0, 0, 0, S.h * 0.62); g.addColorStop(0, "#d9d3c7"); g.addColorStop(1, "#cfc8ba");
      ctx.fillStyle = g; ctx.fillRect(0, 0, S.w, S.h);
      var f = ctx.createLinearGradient(0, S.h * 0.62, 0, S.h); f.addColorStop(0, "#a88f6d"); f.addColorStop(1, "#8d7556");
      ctx.fillStyle = f; ctx.fillRect(0, S.h * 0.62, S.w, S.h * 0.38);
    };
    var draw = function () {
      cv.width = S.w; cv.height = S.h; ctx.clearRect(0, 0, S.w, S.h);
      if (S.bg) ctx.drawImage(S.bg, 0, 0, S.w, S.h); else room();
      if (!S.cut.complete || !S.cut.naturalWidth) return;
      var base = (0.4 * S.w) / S.cut.naturalWidth;
      var w = S.cut.naturalWidth * base * S.sc, h = S.cut.naturalHeight * base * S.sc;
      ctx.save();
      ctx.globalAlpha = S.op;
      ctx.globalCompositeOperation = S.blend === "multiply" ? "multiply" : "source-over";
      ctx.translate(S.x, S.y); ctx.rotate(S.rot * Math.PI / 180); ctx.scale(1, S.tilt);
      ctx.drawImage(S.cut, -w / 2, -h / 2, w, h);
      ctx.restore();
    };
    var reset = function () {
      S.x = S.w / 2; S.y = S.h * 0.62; S.sc = 1; S.rot = 0; S.tilt = 1; S.op = 1;
      ["sc", "rot", "tilt", "op"].forEach(function (k) { var i = $("#t_" + k); if (i) i.value = S[k]; });
      draw();
    };
    $$("[data-try]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", "");
        reset();
      });
    });
    $("#tryClose").addEventListener("click", function () { if (dlg.close) dlg.close(); else dlg.removeAttribute("open"); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
    ["sc", "rot", "tilt", "op"].forEach(function (k) { var i = $("#t_" + k); i.addEventListener("input", function () { S[k] = +i.value; draw(); }); });
    $("#tryReset").addEventListener("click", reset);
    $("#tryFile").addEventListener("change", function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      var img = new Image(), url = URL.createObjectURL(f);
      img.onload = function () {
        var r = Math.min(1, 1600 / Math.max(img.width, img.height));
        S.w = Math.round(img.width * r); S.h = Math.round(img.height * r); S.bg = img;
        if (empty) empty.hidden = true;
        reset(); URL.revokeObjectURL(url);
      };
      img.onerror = function () { toast(T.strings.badImage); };
      img.src = url;
    });

    var ptrs = {};
    var pos = function (e) { var r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) * S.w / r.width, y: (e.clientY - r.top) * S.h / r.height }; };
    cv.addEventListener("pointerdown", function (e) { cv.setPointerCapture(e.pointerId); ptrs[e.pointerId] = pos(e); cv.style.cursor = "grabbing"; });
    cv.addEventListener("pointermove", function (e) {
      if (!ptrs[e.pointerId]) return;
      var p = pos(e), ids = Object.keys(ptrs);
      if (ids.length === 1) { S.x += p.x - ptrs[e.pointerId].x; S.y += p.y - ptrs[e.pointerId].y; }
      else if (ids.length === 2) {
        var o = ids.filter(function (i) { return +i !== e.pointerId; })[0], q = ptrs[o];
        var d0 = Math.hypot(ptrs[e.pointerId].x - q.x, ptrs[e.pointerId].y - q.y), d1 = Math.hypot(p.x - q.x, p.y - q.y);
        if (d0 > 0) { S.sc = Math.max(0.1, Math.min(4, S.sc * d1 / d0)); $("#t_sc").value = S.sc; }
      }
      ptrs[e.pointerId] = p; draw();
    });
    var up = function (e) { delete ptrs[e.pointerId]; cv.style.cursor = "grab"; };
    cv.addEventListener("pointerup", up); cv.addEventListener("pointercancel", up);
    cv.addEventListener("wheel", function (e) {
      e.preventDefault();
      S.sc = Math.max(0.1, Math.min(4, S.sc * (e.deltaY < 0 ? 1.06 : 0.94)));
      $("#t_sc").value = S.sc; draw();
    }, { passive: false });
    $("#tryDl").addEventListener("click", function () {
      try {
        cv.toBlob(function (b) {
          if (!b) { toast(T.strings.dlError); return; }
          var a = d.createElement("a"); a.href = URL.createObjectURL(b); a.download = "chez-moi-" + dlg.getAttribute("data-slug") + ".png";
          d.body.appendChild(a); a.click(); a.remove(); setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
        }, "image/png");
      } catch (err) { toast(T.strings.dlError); }
    });
  }
})();

;(function(){var d=document;function pic(e){var a=e.target&&e.target.closest?e.target.closest('.swatches .dot'):null;if(!a)return null;var c=a.closest('.card');return c?{a:a,p:c.querySelector('.pic')}:null}
function on(e){var o=pic(e);if(!o||!o.p)return;var i=o.p.querySelector('.swimg'),u=o.a.getAttribute('data-img');if(!i||!u)return;if(i.getAttribute('src')!==u)i.setAttribute('src',u);o.p.classList.add('sw-on')}
function off(e){var o=pic(e);if(o&&o.p)o.p.classList.remove('sw-on')}
d.addEventListener('mouseover',on);d.addEventListener('focusin',on);d.addEventListener('mouseout',off);d.addEventListener('focusout',off)})();
